import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';
import {
  RequestScriptDoctorContentData,
  RequestScriptMedicationContentData,
  RequestScriptEmailAddressFormData,
  RequestScriptFaxNumberFormData,
  RequestScriptPharmacyAddressFormData,
  RequestScriptPostAddressFormData,
  RequestScriptDeliveryMethodContentData,
  RequestScriptPatientContentData,
  RequestScriptPatientIdContentData,
} from '@/lib/validation';

type State = {
  patient: RequestScriptPatientContentData | null;
  doctor: RequestScriptDoctorContentData | null;
  medication: RequestScriptMedicationContentData | null;
  deliveryMethod: RequestScriptDeliveryMethodContentData | null;
  emailAddress: RequestScriptEmailAddressFormData['emailAddress'] | null;
  faxNumber: RequestScriptFaxNumberFormData['faxNumber'] | null;
  pharmacyAddress: RequestScriptPharmacyAddressFormData | null;
  postAddress: RequestScriptPostAddressFormData | null;
  patientId: RequestScriptPatientIdContentData | null;
};

type Actions = {
  setData: (data: Partial<State>) => void;
  resetData: (data?: (keyof State)[]) => void;
};

const initialState: State = {
  patient: null,
  doctor: null,
  medication: [
    {
      medicineName: '',
      medicineDosage: '',
      medicineAmount: '',
      medicineNote: '',
    },
  ],
  deliveryMethod: null,
  emailAddress: null,
  faxNumber: null,
  pharmacyAddress: null,
  postAddress: null,
  patientId: null,
};

const useRequestScriptStoreBase = createWithEqualityFn<State & Actions>()(set => ({
  ...initialState,
  setData: data =>
    set(state => ({
      ...state,
      ...data,
    })),
  resetData: data =>
    set(state => {
      if (!data) return initialState;

      data.forEach((name: keyof State) => {
        if (Object.prototype.hasOwnProperty.call(initialState, name)) {
          state[name] = initialState[name];
        }
      });

      return state;
    }),
}));

export const useRequestScriptStore = <U>(
  selector: (state: State & Actions) => U
) => {
  return useRequestScriptStoreBase(selector, shallow);
};
